import BaseController from "controllers/base"
import { placesUri }  from "servos/googlePlaces"
import ProposalSearchWidget from "widgets/proposalSearchWidget"
import FilterForm from "servos/filterForm";
import KaminariPagination from "servos/kaminariPagination"

class Controller extends BaseController {
  call() {
    bindProposalSearchWidget.call(this)
    bindShowLinks.call(this)
    bindFilterProposal.call(this)
  }
};


var bindProposalSearchWidget = function() {
  let elem = this.root
  this.proposalSearchWidget = new ProposalSearchWidget(elem)
}

let bindFilterProposal = function() {
  this.filterForm = new FilterForm(this.root.find('.filtrable'))

  // this.filterForm.send()
}

let bindShowLinks = function() {
  this.root.on('click', '.proposal-item', (e) => {
    window.location = e.currentTarget.parentElement.dataset.url
  })
}

export default Controller;
